var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-container"},[_c('flowleft'),_c('flowmain',{directives:[{name:"show",rawName:"v-show",value:(_vm.curFlowId),expression:"curFlowId"}],key:_vm.curFlowId,on:{"debugger":_vm.openDebugger}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }